<template>
    <panel class="pt-6">
      <div class="flex flex-wrap items-center -mx-2">
        <div class="flex-initial w-full lg:w-1/2 text-sm" >
          <label for="office_contact_number">Sales Contact Number:</label>
          <input type="text" id="office_contact_number" class="block w-4/5 bg-grey-lighter mt-2 mb-6 p-2" disabled :value="office.sales_phone">
        </div>
        <div class="flex-initial w-full lg:w-1/2 text-sm" >
          <label for="personal_contact_number">Lettings Contact Number:</label>
          <input type="text" id="personal_contact_number" class="block w-4/5 bg-grey-lighter mt-2 mb-6  p-2" disabled :value="office.lettings_phone">
        </div>
      </div>
      <div class="flex flex-wrap items-center -mx-2">
        <div class="flex-initial w-full lg:w-1/2 text-sm" >
          <label for="office_email_address_sales" v-if="office.network_id!==7">Office Email Address Sales:</label>
          <label for="office_email_address_sales" v-else>Email Address Sales:</label>
          <input type="text" id="office_email_address_sales" class="block w-4/5 bg-grey-lighter mt-2 mb-6 p-2" disabled :value="office.sales_email">
        </div>
        <div class="flex-initial w-full lg:w-1/2 text-sm" >
          <label for="office_email_address_lettings" v-if="office.network_id!==7">Office Email Address Lettings:</label>
          <label for="office_email_address_lettings" v-else>Email Address Lettings:</label>
          <input type="text" id="office_email_address_lettings" class="block w-4/5 bg-grey-lighter mt-2 mb-6 p-2" disabled :value="office.lettings_email">
        </div>
      </div>
      <div class="flex flex-wrap items-center -mx-2">
        <div class="flex-initial w-full text-sm relative" >
          <label for="office_website_address" v-if="office.network_id!==7">Office Website Address:</label>
          <label for="office_website_address" v-else>Location Micro-site Address:</label>
          <input type="text" id="office_website_address" class="w-full bg-grey-lighter mt-2 mb-6 p-2" disabled :value="office.website">
          <a v-if="office.website" target="_blank" class="w-4 pt-2 absolute" style="top:1.5rem; right: -1.5rem" :href="office.website.startsWith('http')? office.website : 'https://'+office.website">
            <icon name="link"></icon></a>
        </div>
      </div>
      <div class="flex flex-wrap items-center -mx-2">
        <div class="flex-initial w-full text-sm relative" >
          <label for="valuation_request_page">Valuations Request / Contact Us page: </label>
          <i class="tooltip-container fas fa-info-circle text-blue">
            <div class="absolute border border-bg-primary p-2 bg-white shadow z-10 rounded text-sm normal-case mt-1 tooltip-msg pointer-events-none">
              <span class="text-black font-serif">This should be your a link to a page on your website where a customer can request a property valuation.</span>
            </div>
          </i>
          <input type="text" id="valuation_request_page" placeholder="www.nurtur.group/valuation"
                 class="w-full mt-2 mb-6 p-2 border" v-model="office.valuation_request_url">
          <a v-if="office.valuation_request_url" target="_blank" class="w-4 pt-2 absolute" style="top:1.5rem; right: -1.5rem" :href="office.valuation_request_url">
            <icon name="link"></icon></a>
        </div>
      </div>
      <hr class="border-b w-full">
      <div class="flex flex-wrap items-center -mx-2 mt-4">
        <div class="flex-initial w-full text-sm" >
          <span class="font-bold">Preferred URL link for automated campaigns (i.e. 20/20, APS cards): </span>
          <div class="flex justify-center items-center w-full mt-4">
            <div class="form-check form-check-inline flex items-center w-1/3">
              <input id="sales-contact-number" class="visible" type="radio" name="property_url" @change="office.property_url='sales_phone'; customFlag=false" :checked="office.property_url==='sales_phone'">
              <label class="text-xs" for="sales-contact-number">Sales Contact Number</label>
            </div>
            <div class="form-check form-check-inline flex items-center w-1/3">
              <input id="sales-email-address" class="visible" type="radio" name="property_url" @change="office.property_url='sales_email'; customFlag=false" :checked="office.property_url==='sales_email'">
              <label class="text-xs" for="sales-email-address">Sales Email Address</label>
            </div>
            <div class="form-check form-check-inline flex items-center w-1/3">
              <input id="office-website-address" class="visible" type="radio" name="property_url" @change="office.property_url='website'; customFlag=false" :checked="office.property_url==='website'">
              <label class="text-xs" for="office-website-address"  v-if="office.network_id!==7">Office Website Address</label>
              <label class="text-xs" for="office-website-address"  v-else>Location Micro-site Address</label>
            </div>
          </div>
          <div class="flex justify-center items-center w-full mt-4">
            <div class="form-check form-check-inline flex items-center w-1/3">
              <input id="letting-contact-number" class="visible" type="radio" name="property_url" @change="office.property_url='lettings_phone'; customFlag=false" :checked="office.property_url==='lettings_phone'">
              <label class="text-xs" for="letting-contact-number">Letting Contact Number</label>
            </div>
            <div class="form-check form-check-inline flex items-center w-1/3">
              <input id="letting-email-address" class="visible" type="radio" name="property_url" @change="office.property_url='lettings_email'; customFlag=false" :checked="office.property_url==='lettings_email'">
              <label class="text-xs" for="letting-email-address">Letting Email Address</label>
            </div>
            <div class="form-check form-check-inline flex items-center w-1/3">
              <input id="office-location" class="visible" type="radio" name="property_url" @change="office.property_url='location'; customFlag=false" :checked="office.property_url==='location'">
              <label class="text-xs" for="office-location">Office Location</label>
            </div>
          </div>
          <div class="flex justify-center items-center w-full mt-4">
            <input id="custom-url" class="visible" type="radio" name="property_url" @change="customFlag=true; office.property_url=''" :checked="customFlag===true">
            <label class="text-xs mr-2" for="custom-url">Custom Url: </label>
            <i class="tooltip-container fas fa-info-circle text-blue">
              <div class="absolute border border-bg-primary p-2 bg-white shadow z-10 rounded text-sm normal-case mt-1 tooltip-msg pointer-events-none">
                <span class="text-black font-serif">This should be the URL link for the website page you would like people scanning your automated flyers to visit, for example your valuation request page or staff page.</span>
              </div>
            </i>
            <input type="text" id="property_url" class="w-full mt-2 mb-6 ml-2 p-2 border"
                 placeholder="www.nurtur.group/property-for-sale/" v-model="office.property_url" :disabled="!customFlag">
          </div>
        </div>
      </div>
      <div class="flex flex-wrap items-center -mx-2">
        <div class="block w-full text-sm font-bold mb-2">Office Location:</div>
        <div class="flex-initial w-full lg:w-1/2 text-sm" >
          <label for="latitude">Latitude:</label>
          <input type="text" id="latitude" class="block w-4/5 bg-grey-lighter mt-2 mb-6 p-2" disabled :value="office.lat">
        </div>
        <div class="flex-initial w-full lg:w-1/2 text-sm relative" >
          <label for="longtitue">Longtitude:</label>
          <input type="text" id="longtitue" class="block w-4/5 bg-grey-lighter mt-2 mb-6  p-2" disabled :value="office.lon">
          <div class="w-4 pt-2 absolute cursor-pointer" style="top:1.5rem; right: -1.5rem" @click="showMap=!showMap">
            <icon name="location-dot-solid"></icon></div>
        </div>
        <GmapMap
          v-if="showMap"
          :center="this.coords"
          :zoom="15"
          :options="{disableDefaultUI: true, zoomControl: true}"
          map-type-id="roadmap"
          class="w-full h-64 mb-5"
        >
          <GmapMarker
            :position="coords"
            :clickable="true"
            :draggable="true"
          />
        </GmapMap>
      </div>
    </panel>
</template>

<script>
import { mapState } from 'vuex'
import { v2Api } from '@/http'
import { debounce, toNumber } from 'lodash'

export default {
  name: 'Settings',
  data () {
    return {
      showMap: false,
      customFlag: false
    }
  },
  methods: {
    updateQrCodeSetting: debounce(function () {
      v2Api.post(`/qr-code-settings/${this.office.id}`, {
        valuation_request_url: this.office.valuation_request_url,
        property_url: this.office.property_url
      }).catch(() => {
        alert('Unable to update Qr Code setting')
      })
    }, 1000)
  },
  computed: {
    ...mapState({
      office: state => state.selectedOffice
    }),
    coords () {
      return {
        lat: toNumber(this.office.lat),
        lng: toNumber(this.office.lon)
      }
    }
  },
  watch: {
    office: {
      handler () {
        this.updateQrCodeSetting()
      },
      deep: true
    }
  },
  mounted () {
    if (this.office.website === '' || this.office.website === null) {
      this.office.website = this.office.network_id === 7 ? 'https://www.fineandcountry.com/uk' : this.office.website
    }
    switch (this.office.property_url) {
      case 'sales_phone':
      case 'sales_email':
      case 'website':
      case 'lettings_phone':
      case 'lettings_email':
      case 'location':
        break
      default:
        if (this.office.property_url === '' || this.office.property_url === null || this.office.property_url === this.office.website) {
          this.office.property_url = 'website'
        } else {
          this.customFlag = true
        }
    }
  }

}
</script>
<style scoped>
input[type="radio"] {
  display: inline-block;
}

input[type="radio"] + label {
  cursor: pointer;
  white-space: nowrap;
  display: inline-block;
  position: relative;
  line-height: 1rem;
}

input[type="radio"]:checked + label::before {
  content: "";
  border-width: 0px;
}

input[type="radio"]:checked + label::before {
  background: white;
}
input[type="radio"] + label::before {
  content: '';
  display: inline-block;
  width: 0px;
  height: 0px;
  margin-right: 5px;
  border: 0px;
  padding: 0px;
  background: white;
}
</style>
